import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgContestSign = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 48, height: 48, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V44C48 46.2091 46.2091 48 44 48H4C1.79086 48 0 46.2091 0 44V4Z", fill: fillSecondary }), /* @__PURE__ */ React.createElement("path", { d: "M14.9259 19.4641C14.9259 19.9339 15.3675 20.7277 16.3559 21.4404C16.8623 21.8049 17.4334 22.0965 18.0451 22.3071C17.7616 21.2946 17.5671 20.1364 17.5266 18.8161H14.9259V19.4641Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M31.6441 21.4404C32.3571 20.9261 33.0741 20.1161 33.0741 19.4641V18.8161H30.4693C30.4288 20.1364 30.2344 21.2946 29.9508 22.3071C30.5625 22.0965 31.1377 21.8049 31.6441 21.4404Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 2C2.89543 2 2 2.89543 2 4V44C2 45.1046 2.89543 46 4 46H44C45.1046 46 46 45.1046 46 44V4C46 2.89543 45.1046 2 44 2H4ZM30.4815 16.2241H34.6944C35.2332 16.2241 35.6667 16.6575 35.6667 17.1961V19.4641C35.6667 20.9099 34.7512 22.3962 33.1591 23.5424C31.8872 24.4617 30.3356 25.0449 28.7031 25.2312C27.4311 27.3412 25.9444 28.2119 25.9444 28.2119V31.1279H27.8889C29.3189 31.1279 30.4815 31.9662 30.4815 33.3959V33.8818C30.4815 34.1491 30.2627 34.3678 29.9954 34.3678H18.0046C17.7373 34.3678 17.5185 34.1491 17.5185 33.8818V33.3959C17.5185 31.9662 18.6811 31.1279 20.1111 31.1279H22.0556V28.2119C22.0556 28.2119 20.5689 27.3412 19.2969 25.2312C17.6684 25.0449 16.1169 24.4617 14.8409 23.5424C13.2448 22.3962 12.3333 20.9099 12.3333 19.4641V17.1961C12.3333 16.6575 12.7668 16.2241 13.3056 16.2241H17.5185V14.6041C17.5185 14.0655 17.952 13.6322 18.4907 13.6322H29.5093C30.048 13.6322 30.4815 14.0655 30.4815 14.6041V16.2241Z", fill: props.fill }));
});
export default SvgContestSign;
